import React, { useState, useEffect } from "react";

interface LandingPageProps {
  onLogin: () => void;
}

const Header: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      if (!target.closest(".mobile-menu") && !target.closest(".hamburger-button")) {
        setIsMobileMenuOpen(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? "bg-[#0d0d0d]/95 backdrop-blur-sm border-b border-gray-800" : "bg-transparent"
      }`}
    >
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center space-x-2">
            <svg
              className="w-6 h-6 text-gray-500"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
              />
            </svg>
            <span className="text-sm font-light text-gray-500 tracking-[0.2em] uppercase">Centrum Testowe</span>
          </div>

          <div className="hidden md:block">
            <button
              onClick={() => (window.location.href = "/login")}
              className="text-gray-500 hover:text-gray-400 text-xs tracking-[0.15em] uppercase transition-colors duration-300"
            >
              Wejdź
            </button>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden hamburger-button p-2 text-gray-500 hover:text-gray-400 transition-colors"
            aria-label="Menu"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {isMobileMenuOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>

        <div
          className={`md:hidden mobile-menu absolute left-0 right-0 bg-[#0d0d0d] border-b border-gray-800 transition-all duration-300 ${
            isMobileMenuOpen ? "opacity-100 visible" : "opacity-0 invisible"
          }`}
        >
          <div className="px-4 py-3">
            <button
              onClick={() => (window.location.href = "/login")}
              className="w-full px-4 py-2 text-gray-500 hover:text-gray-400 text-xs tracking-widest uppercase text-left"
            >
              Wejdź
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

const LandingPage: React.FC<LandingPageProps> = () => {
  return (
    <div className="min-h-screen bg-[#0d0d0d] text-gray-400">
      <Header />

      <main className="relative flex flex-col items-center justify-center min-h-[calc(100vh-8rem)] px-4">
        <h1 className="text-3xl sm:text-4xl font-light text-gray-300 tracking-[0.35em] uppercase mb-6">
          Centrum Testowe
        </h1>
        <p className="text-sm text-gray-500 tracking-widest mb-16 max-w-xs text-center">
          —
        </p>

        <button
          onClick={() => (window.location.href = "/login")}
          className="text-gray-500 hover:text-gray-300 text-sm tracking-[0.2em] uppercase transition-colors duration-300 border border-gray-600 hover:border-gray-500 px-8 py-3 rounded-sm"
        >
          Wejdź
        </button>
      </main>

      <footer className="py-6 text-center text-xs text-gray-600 tracking-widest">
        © {new Date().getFullYear()}
      </footer>
    </div>
  );
};

export default LandingPage;
